import React, { useEffect, useState } from 'react';
import OfficeService from './officeService';

const OfficeSearch = () => {
  const [offices, setOffices] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchOffices = async () => {
      const officeService = new OfficeService();
      try {
        const data = await officeService.getAllOffices();
        setOffices(data);
      } catch (err) {
        setError(err.message);
      }
    };
    fetchOffices();
  }, []);

  const handleSelect = (office) => {
    if (window.opener) {
      window.opener.postMessage(
        {
          inputTarget: 'officeId', // this should match what the parent is listening for
          value: office.officeId,
          displayName: office.officeName,
        },
        '*'
      );
      window.close();
    }
  };

  return (
    <div style={styles.container}>
      <h2>Select an Office</h2>
      {error && <div style={styles.error}>{error}</div>}
      <ul style={styles.list}>
        {offices.map((office) => (
          <li
            key={office.officeId}
            style={styles.item}
            onClick={() => handleSelect(office)}
          >
            <strong>{office.officeName}</strong><br />
            <span>{office.address}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    padding: '20px',
    maxWidth: '600px',
    margin: '0 auto',
  },
  error: {
    color: 'red',
    marginBottom: '1em',
  },
  list: {
    listStyle: 'none',
    padding: 0,
  },
  item: {
    padding: '12px',
    marginBottom: '10px',
    border: '1px solid #ccc',
    borderRadius: '8px',
    cursor: 'pointer',
    background: '#f9f9f9',
    transition: 'background 0.2s',
  },
};

export default OfficeSearch;
